module.exports = __webpack_public_path__ + "static/img/logo_ps.224600a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo_ps.png
// module id = vMIl
// module chunks = 1